import { configureStore } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';
import loggerMiddleware from './middleware/logger';
import { rootReducer } from './reducers';

export default configureStore({
  reducer: rootReducer,
  middleware: [thunkMiddleware, loggerMiddleware]
});
